export const ScreenNames = {
  HOME: 'Dashboard',
  UNAUTHORIZED_ACCESS: 'Unauthorized Access',
  NOT_FOUND: 'Not Found',
  USER_MANAGEMENT: 'User Management',
  ROLES: 'Roles',
  USERS: 'Users',
  CONFIG: 'Configs',
  SITE_LEVEL_CONFIG: 'Site Level',
  ROLE_LEVEL_CONFIG: 'Role Level',
  SITE_VIEW: 'Site',
  SITE_MANAGEMENT: 'Site Management',
  SHIFT_OF_SITE_VIEW: 'Shifts',
  SHIFT_MANAGEMENT: 'Shift Management',
  ROSTER_MANAGEMENT: 'Roster Management',
  MULTI_SITE_ROSTER_MANAGEMENT: 'Roster Management',
  ATTENDANCE_SUMMARY: 'Attendance Summary',
  AREA_MANAGEMENT: 'Area Management',
  LEAVES: 'Leaves & Holidays',
  HOLIDAY_CONFIGURATIONS: 'Holiday Configuration',
  LEAVE_CONFIGURATIONS: 'Leave Configuration',
  SEPARATION: 'Separations',
  TERMINATION: 'Termination',
  SEPARATION_OPEN_REQUESTS: 'Open Requests',
  SEPARATION_CLOSED_REQUESTS: 'Closed Requests',
  APPROVAL_ABSCONDING_OPEN_REQUESTS: 'Open Requests',
  APPROVAL_ABSCONDING_CLOSED_REQUESTS: 'Closed Requests',
  APPROVAL: 'Approvals',
  APPROVAL_LEAVES: 'Leaves',
  APPROVAL_LEAVES_OPEN_REQUESTS: 'Open Requests',
  APPROVAL_LEAVES_CLOSED_REQUESTS: 'Closed Requests',
  APPROVAL_SEPARATION: 'Separations',
  APPROVAL_ABSCONDING: 'Absconding',
  APPROVAL_SEPARATION_OPEN_REQUESTS: 'Open Requests',
  APPROVAL_SEPARATION_CLOSED_REQUESTS: 'Closed Requests',
  SEPARATION_HISTORY_OPEN_REQUESTS: 'Open Requests',
  SEPARATION_HISTORY_CLOSED_REQUESTS: 'Closed Requests',
  REGULARISATION: 'Regularisation',
  BULK_UPLOAD: 'Bulk Upload',
  BULK_REGULARIZATION: 'Bulk Regularisation',
  BULK_USER: 'Bulk User',
  BULK_GRACE_ATTENDANCE: 'Bulk Grace Attendance',
  BULK_ROLE_UPDATE: 'Bulk Role Update',
  PUNCH_IN: 'Punch In',
  PUNCH_OUT: 'Punch Out',
  OT_TOP_UP: 'OT Top-ups',
  SPOOF: 'Attendance Spoofs',
  BLACKLIST_EMPLOYEE: 'Blacklisting',
  PLANED_OT: 'Planned OTs',
  ATTENDANCE_LOG: 'Attendance Log',
  MULTI_SESSION: 'Attendance Session',
  ATTENDANCE_REQUEST: 'Attendance Request',
  OVERTIME_MANAGEMENT: 'Overtime Management',
  SCHEDULED_OT_STATUS: 'Overtime Employees',
  REPORTS: 'Reports',
  UPLOAD_REPORTS_MODULE: 'Upload Reports',
  DOWNLOAD_REPORTS_MODULE: 'Download Reports',
  ONBOARDING_TRACKER: 'Onboarding Status',
  CANDIDATE_PRE_ONBOARDING: 'Pre-Onboarding',
  TEAM_MANAGEMENT: 'Team',
  VENDOR_PAYOUT_VIEW: 'Vendor Payout',
  APPROVAL_BGV: 'Background Verification',
  APPROVAL_BGV_OPEN_REQUESTS: 'Open Requests',
  APPROVAL_BGV_CLOSED_REQUESTS: 'Closed Requests',
  VENDORS: 'Vendors',
  VENDOR_REPORT: 'Vendor Report',
  CREATE_OT: 'Create Overtime',
  CREATE_PLANNED_OT: 'Create Planned OT',
  CREATE_ADHOC_OT: 'Create Adhoc OT',
  EDIT_EMPLOYEES: 'Edit Employees',
  SLOT_MANAGEMENT: 'Slot Management',
  RATE_CARD_MANAGEMENT: 'Rate Card Management',
  FLEX_MANAGEMENT: 'Flex',
  FT_FLEX: 'FT Flex',
  FLEX_SITE_MANAGEMENT: 'Site Management',
  FLEX_SITE_MANAGEMENT_DETAILS: 'Site Details',
  FLEX_PAYOUT_MANAGEMENT: 'Payroll Management',
  GRIEVANCE_MANAGEMENT: 'Grievance Management',
  GRIEVANCE_DETAILS: 'Grievance Details',
  TRANSFER_MODULE: 'Transfers',
  TRANSFER_REQUESTS_TRACKER: 'Requests',
  TRANSFER_EMPLOYEE_HISTORY: 'Employees',
  TRANSFER_EMPLOYEE_INCOMING_HISTORY: 'Incoming',
  TRANSFER_EMPLOYEE_OUTGOING_HISTORY: 'Outgoing',
  TRANSFER_OPEN_REQUESTS: 'Open Requests',
  TRANSFER_CLOSED_REQUESTS: 'Closed Requests',
  TRANSFER_REQUESTS_TRACKER_DETAILS: 'Transfer Details',
  APPROVAL_TRANSFERS: 'Transfers',
  APPROVAL_TRANSFERS_OPEN_REQUESTS: 'Open Requests',
  APPROVAL_TRANSFERS_CLOSED_REQUESTS: 'Closed Requests',
  VENDOR_LEVEL_PAYOUT: 'Vendor Level Payouts',
  ROSTER_PLAN: 'Roster Plan',
  REFERRAL_RATE_CARD_MANAGEMENT: 'Referral',
  JOB_OPENING_MAPPINGS: 'Job Openings',
  ADDENDUM_MANAGEMENT: 'Addendum',
  ADDENDUM_DETAILS: 'Addendum Details',
  IT_APPROVALS: 'IT Approvals',
  IT_APPROVALS_SEPARATION: 'Separation',
  IT_APPROVALS_EMPLOYEE_ASSET: 'Employee Asset',
  IT_APPROVALS_EMPLOYEE_ASSET_OPEN_REQUESTS: 'Open Requests',
  IT_APPROVALS_EMPLOYEE_ASSET_CLOSED_REQUESTS: 'Closed Requests',
  APPROVAL_IT_REVIEW: 'IT Review',
  APPROVAL_IT_REVIEW_OPEN_REQUESTS: 'Open Requests',
  APPROVAL_IT_REVIEW_CLOSED_REQUESTS: 'Closed Requests',
  POST_ONBOARDING: 'Post Onboarding',
  POST_ONBOARDING_OPEN_REQUESTS: 'Open Requests',
  POST_ONBOARDING_CLOSED_REQUESTS: 'Closed Requests',
};
